import React from "react"
import { Link } from "gatsby"
import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { CarouselSection } from "../../../CarouselSection"
import { SonorizacionImg } from "../../../CarouselImages/SonorizacionImg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import "./info.scss"
import "./carousel.scss"

export const InfoSection = ({ classTitle, mainTitle }) => {
  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={mainTitle.toUpperCase()}
          cNameSolucion={classTitle}
        />

        <div className={`info-${classTitle}-detalles-container`}>
          <div
            className={`info-${classTitle}-detalles-text-descripcion`}
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-easing="ease"
          >
            <h3>SONORIZACIÓN</h3>
            <p>
              Ofrecemos la mayor y mejor oferta de productos, prestaciones y
              soluciones estéticas para instalaciones de sonido y microfonía.
            </p>
          </div>
          <div
            className={`info-${classTitle}-detalles-text`}
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-easing="ease"
          >
            <div className={`info-${classTitle}-detalles-text-equip-container`}>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>
                  Sistemas de sonorización, intercomunicación y megafonía para
                  instalaciones comerciales y públicas.
                </span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>
                  Sistemas de intercomunicación asistencial para residencias
                  geriátricas y hospitales, así como para pequeñas
                  instalaciones.
                </span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Sistemas de audio, intercomunicación y domótica.</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>
                  Altavoces y difusores acústicos. Streaming de tu música con
                  Bluetooth.
                </span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>
                  Sistemas de microfonía profesionales (de mesa, solaperos e
                  inalámbricos) para salas de conferencias y auditorios.
                </span>
              </div>
            </div>
          </div>
          <CarouselSection
            classTitle={classTitle}
            images={SonorizacionImg}
            s1920="530px"
            s1366="490px"
            s1024="327px"
            s768="228px"
            s640="228px"
            s360="192px"
          />
        </div>

        <div
          className={`info-${classTitle}-button-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <Link className="soluciones-btn" to="/contacto">
            <button className={`${classTitle}-btn-cotizar"`}>COTIZAR</button>
          </Link>
        </div>

        <BarraSoluciones />
      </div>
    </>
  )
}
